import React from 'react';
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'

const MovimientosFabricaComponent = ({ fabrica }) => {
    console.log(fabrica)
    const ingresos = fabrica.find((item) => item.ingreso)?.ingreso || [];
    const altas = fabrica.find((item) => item.alta)?.alta || [];
    const movimientos = fabrica.find((item) => item.movimientos)?.movimientos || [];
    const traslados = fabrica.find((item) => item.traslados)?.traslados || [];
    const instalacion = fabrica.find((item) => item.instalacion)?.instalacion || '';
    const recepcionTR = fabrica.find((item) => item.recepcionTR)?.recepcionTR || [];

    return (
        <div className="container mt-4">
            {/* Ingresos */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Ingresos</h5>
                    {ingresos.map((ingreso, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{ingreso.loteGranel}
                            <br />
                            <strong>Producción: </strong> {ingreso.produccion} - <strong>Fecha: </strong>{ingreso.fecha} - <strong>Litros Producidos: </strong>{ingreso.litros} - <strong>Grados: </strong>{ingreso.grado}
                            <br />
                            <strong>Inspector: </strong>{ingreso.inspector}
                        </p>
                    ))}
                </div>
            </div>

            {/* Altas */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Altas</h5>
                    {altas.map((alta, index) => (
                        <p key={index} className="card-text">
                            <strong> Lote: </strong>{alta.lote} -
                            <strong> Categoria: </strong>{alta.categoria} -
                            <strong> Clase: </strong>{alta.clase} -
                            <strong> Fecha: </strong>{alta.fecha} -
                            <strong> Grado: </strong>{alta.grado} -
                            <strong> Litros: </strong>{alta.litros} -
                            <strong> Inspector: </strong>{alta.inspector}
                        </p>
                    ))}
                </div>
            </div>

            {/* Movimientos */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Movimientos</h5>
                    {movimientos.map((movimiento, index) => (
                        <div key={index} className="card mb-2">
                            <div className="card-body">
                                <p className="card-text">
                                    <strong>Folio:</strong> {movimiento.folio}
                                </p>
                                <p className="card-text">
                                    <strong>Lote Granel:</strong> {movimiento.loteGranel} - <strong>Lote Dos:</strong> {movimiento.loteDos}
                                </p>
                                <p className="card-text">
                                    <strong>Descripción:</strong> {movimiento.descripcion} - <strong>Fecha:</strong> {movimiento.fecha}
                                </p>
                                <p className="card-text">
                                    <strong>Litros:</strong> {movimiento.litros} - <strong>Grado:</strong> {movimiento.grado}
                                </p>
                                <p className="card-text">
                                    <strong>Inspector:</strong> {movimiento.inspector}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Traslados */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Traslados</h5>
                    {traslados.map((traslado, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{traslado.lote}
                            <br />
                            {`Salida: ${traslado.clienteSalida} (${traslado.instalacionSalida}) - Destino: ${traslado.clienteDestino} (${traslado.instalacionDestino}) - Fecha: ${traslado.fecha} - Litros: ${traslado.litros}`}
                        </p>
                    ))}
                </div>
            </div>
            {/* Recepción de Traslados */}
            <div className="card">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Recepción de Traslados</h5>
                    {recepcionTR.map((recepcion, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{recepcion.lote}
                            <br />
                            {`Salida: ${recepcion.clienteSalida} (${recepcion.instalacionSalida}) - Destino: ${recepcion.clienteDestino} (${recepcion.instalacionDestino}) - Fecha: ${recepcion.fecha} - Litros: ${recepcion.litros}`}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MovimientosFabricaComponent;
